export const AUTH_STORAGE_KEYS = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  userData: 'userData',
  effectiveTenantId: 'effectiveTenantId',
  effectiveUnidadeId: 'effectiveUnidadeId',
} as const;

export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized';

export const API_V1_PREFIX = '/api/v1';
